import React from 'react'
import slaRepository from '../../SlaRepository'
import TableFilaSolicitacoesAnaliseDocumentosBase from './TableFilaSolicitacoesAnaliseDocumentosBase'
import useQueryFilter from '../../useQueryFilter'

const TableFilaSolicitacoesAnaliseDocumentosCompleta = ({
  setQuantidade,
  ...props
}) => {
  const [query] = useQueryFilter(props.location.search)

  const fetch = () => {
    return slaRepository.filaAtual({
      empresaId: query.empresaId,
      analiseDocumentos: true
    })
  }

  return (
    <TableFilaSolicitacoesAnaliseDocumentosBase
      tipoAnaliseDocumento="Documentos"
      setQuantidade={setQuantidade}
      fetch={fetch}
      {...props}
    />
  )
}

export default React.memo(TableFilaSolicitacoesAnaliseDocumentosCompleta)
